import styled from "styled-components";

export const Container = styled.div<{ isOpenMenu: boolean }>`
    position: absolute;
    bottom: 27px;
    left: ${({ isOpenMenu }) => (isOpenMenu ? "470px" : "25px")};
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    max-width: 380px;
    z-index: 1000;
    border: 1px solid rgba(0, 0, 0, 0.08);

`;

export const MapLegendHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
`;

export const MapLegendHeaderTitle = styled.div`
    font-size: 16px;
    font-weight: 600;
    color: #424242;
    display: flex;
    align-items: center;
    gap: 8px;

    svg {
        font-size: 20px;
        color: #2196f3;
    }
`;

export const MapLegendContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    max-height: 260px;
    overflow-y: auto;
    padding-right: 4px;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.25);
        border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }
`;

export const MapLegendContentItem = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 12px;
    background: #f8f9fa;
    border-radius: 8px;
    transition: background 0.2s ease;
`;

export const MapLegendColor = styled.div<{ backgroundColor: string; $selected?: boolean }>`
    width: 18px;
    height: 18px;
    border-radius: 4px;
    border: 2px solid ${(props) => (props.$selected ? "#FF0000" : "rgba(0, 0, 0, 0.1)")};
    background: ${(props) => props.backgroundColor};
    box-sizing: border-box;

    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    box-shadow: inset 0 0 0 1000px ${(props) => props.backgroundColor};
`;

export const MapLegendDate = styled.div`
    font-size: 13px;
    font-weight: 500;
    color: #424242;
    min-width: 70px;
`;

export const MapLegendStats = styled.div`
    font-size: 12px;
    color: #666;
    flex: 1;
`;

export const MapLegendTotals = styled.div`
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #e0e0e0;
`;

export const MapLegendTotalItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;
`;

export const MapLegendTotalLabel = styled.div`
    font-size: 12px;
    color: #666;
`;

export const MapLegendTotalValue = styled.div`
    font-size: 13px;
    font-weight: 600;
    color: #2196f3;
`;

export const ContentFlex = styled.div`
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;

    div {

        h4 {
            font-weight: 700;
            margin-bottom: 5px;
        }
    
        p {
            font-size: 13px;
        }
    }

`;

export const IconStyled = styled.div`
    width: 80px;
    height: 30px;
    border-radius: 8px;
    background-color: #2C2F33;
    position: relative;

    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;

    &::after {
        content: "N";
        position: absolute;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background-color: #ff0000;
        color: #FFF;
        font-size: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        top: -4px;
        right: -2px;
    }



`;